import { NextPage } from 'next';
import styled from 'styled-components';
import Markdown from 'react-markdown';
import ButtonComponentNextDirection from 'components/atoms/buttons/Sign';
import ButtonComponentReturnMain from 'components/atoms/buttons/ReturnMain';

import Link from 'next/link';

const Header = styled.div`
  /* Desktop/Heading/H1 */

  font-family: Cormorant;
  font-style: normal;
  font-weight: 600;
  font-size: 55px;
  line-height: 120%;
  /* identical to box height, or 66px */

  letter-spacing: 0.01em;
  text-transform: uppercase;

  /* Neutral/black */

  color: #292838;

  @media screen and (max-width: 1024px) {
    font-size: 35px;
  }

  span {
    display: block;
  }
`;
const HeaderDescription = styled(Markdown)`
  font-family: Jost;
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 170%;
  color: #292838;
`;

const Galery = styled.div`
  padding: 40px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  /* Compensate for excess margin on outer gallery flex items */
  margin: -1rem -1rem;
  @supports (display: grid) {
    display: grid;
    //grid-template-rows: repeat(auto-fit, minmax(15rem, 1fr));
    grid-template-columns: 10px auto auto auto 10px;
    grid-template-rows: 10px auto 10px auto 10px;
    grid-gap: 2rem;
    margin: 0;
  }
  @media screen and (max-width: 1024px) {
    padding: 0px;
  }
`;

export const ButtonComponentNextDirectionWrapper = styled(
  ButtonComponentNextDirection,
)``;
export const ButtonComponentReturnMainWrapper = styled(
  ButtonComponentReturnMain,
)``;

export const ButtonPosition = styled.div`
  margin-top: 40px;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
`;

export const ButtonAncor = styled.a`
  text-decoration: none;
`;

const GaleryItem1 = styled.div`
  position: relative;
  //width: 500px;
  flex-grow: 1;
  z-index: 1;
  //right: 150px;
  //margin-left: 450px;

  /* Minimum width of 24rem and grow to fit available space */
  flex: 1 0 24rem;
  /* Margin value should be half of grid-gap value as margins on flex items don't collapse */
  margin: 1rem;
  //box-shadow: 0.3rem 0.4rem 0.4rem rgba(0, 0, 0, 0.4);
  overflow: hidden;
  @supports (display: grid) {
    grid-column: 2/7;
    grid-row: 1/ 6;

    margin: 0;
  }
  @media screen and (max-width: 1024px) {
    grid-column: 1/10;
    grid-row: 1/ 10;
    z-index: 0;
  }
`;
const GaleryItem2 = styled.div`
  position: relative;
  height: auto;
  //width: 500px;
  flex-grow: 2;
  /* Minimum width of 24rem and grow to fit available space */
  //top: 450px;
  //bottom: 50px;
  //left: 75px;
  flex: 1 0 24rem;
  /* Margin value should be half of grid-gap value as margins on flex items don't collapse */
  margin: 1rem;
  //box-shadow: 0.3rem 0.4rem 0.4rem rgba(0, 0, 0, 0.4);
  overflow: hidden;
  @media screen and (max-width: 1024px) {
    display: none;
  }
  @supports (display: grid) {
    margin: 0;
    grid-column: 3 / 8;
    grid-row: 5/ 10;
  }
`;

const GaleryImage = styled.img`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;

  object-fit: cover;
  transition: transform 400ms ease-out;
  :hover {
    transform: scale(1.15);
  }
`;
const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;
  @media screen and (max-width: 1024px) {
    padding: 0px;
  }
`;

const GalleryWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.background};
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 1024px) {
    flex-wrap: wrap-reverse;
  }

  max-width: 100rem;
  margin: 0 auto;
  padding: 0 1rem 1rem;

  .gallery-image {
  }
`;
export type DirectionImageT = {
  src: string;
  alt: string;
};
export type DirectionPageT = {
  headerName?: string;
  headerDescription?: string;
  buttonDirectionRedirectName?: string;
  buttonDirectionRedirectLink?: string;
  images?: DirectionImageT[] | undefined;
};

const DirectionPageComponent: NextPage<DirectionPageT> = ({
  headerName,
  headerDescription,
  buttonDirectionRedirectName,
  buttonDirectionRedirectLink,
  images,
}) => {
  return (
    <GalleryWrapper>
      <HeaderWrapper>
        <Header>{headerName}</Header>
        <HeaderDescription>{headerDescription}</HeaderDescription>
        <ButtonPosition>
          <Link href={buttonDirectionRedirectLink} passHref>
            <ButtonAncor>
              <ButtonComponentNextDirectionWrapper
                text={buttonDirectionRedirectName}
              ></ButtonComponentNextDirectionWrapper>
            </ButtonAncor>
          </Link>
          <Link href="/" passHref>
            <ButtonAncor>
              <ButtonComponentReturnMainWrapper text="ВЕРНУТЬСЯ НА ГЛАВНУЮ"></ButtonComponentReturnMainWrapper>
            </ButtonAncor>
          </Link>
        </ButtonPosition>
      </HeaderWrapper>

      <Galery>
        {images.map((img, id) => {
          if (id == 0) {
            return (
              <GaleryItem1 key={id}>
                <GaleryImage src={img.src} alt={img.alt}></GaleryImage>
              </GaleryItem1>
            );
          }
          if (id == 1) {
            return (
              <GaleryItem2 key={id}>
                <GaleryImage src={img.src} alt={img.alt}></GaleryImage>
              </GaleryItem2>
            );
          }
        })}
      </Galery>
    </GalleryWrapper>
  );
};
export default DirectionPageComponent;

/*
import { NextPage } from 'next';
import styled from 'styled-components';
import Markdown from 'react-markdown';

const Header = styled.div`
  text-align: center;

  color: #292838;
  font-size: ${(props) => props.theme.fonts.heading.size};
  font-family: ${(props) => props.theme.fonts.heading.family};
  font-weight: ${(props) => props.theme.fonts.heading.weight};
  line-height: ${(props) => props.theme.fonts.heading.lineHeight};
  padding: 0.1rem 0;

  @media screen and (max-width: 1024px) {
    font-size: 35px;
  }

  span {
    display: block;
  }
`;
const HeaderDescription = styled(Markdown)`
  font-family: Jost;
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 170%;
  color: #292838;
`;

const Galery = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -1rem -1rem;
  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
    grid-gap: 2rem;
    margin: 0;
  }
`;

const GaleryItem = styled.div`
  flex: 1 0 24rem;
  margin: 1rem;
  box-shadow: 0.3rem 0.4rem 0.4rem rgba(0, 0, 0, 0.4);
  overflow: hidden;
  @supports (display: grid) {
    margin: 0;
  }
`;

const GaleryImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 400ms ease-out;
  :hover {
    transform: scale(1.15);
  }
`;

const GalleryWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.background};
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  max-width: 100rem;
  margin: 0 auto;
  padding: 0 2rem 2rem;

  .gallery-image {
  }
`;
export type DirectionImageT = {
  src: string;
  alt: string;
};
export type DirectionPageT = {
  headerName?: string;
  headerDescription?: string;
  images?: DirectionImageT[] | undefined;
};

const DirectionPageComponent: NextPage<DirectionPageT> = ({
  headerName,
  headerDescription,
  images,
}) => {
  return (
    <GalleryWrapper>
      <Header>{headerName}</Header>
      <HeaderDescription>{headerDescription}</HeaderDescription>

      <Galery>
        {images.map((img, id) => (
          <GaleryItem key={id}>
            <GaleryImage src={img.src} alt={img.alt}></GaleryImage>
          </GaleryItem>
        ))}
      </Galery>
    </GalleryWrapper>
  );
};
        <GaleryItem>
          <GaleryImage
            src="https://images.unsplash.com/photo-1515260268569-9271009adfdb?w=500&h=500&fit=crop"
            alt="sunset behind San Francisco city skyline"
          ></GaleryImage>
        </GaleryItem>

        <GaleryItem>
          <GaleryImage
            src="https://images.unsplash.com/photo-1506045412240-22980140a405?w=500&h=500&fit=crop"
            alt="people holding umbrellas on a busy street at night lit by street lights and illuminated signs in Tokyo, Japan"
          ></GaleryImage>
        </GaleryItem>

        <GaleryItem>
          <GaleryImage
            src="https://images.unsplash.com/photo-1514041181368-bca62cceffcd?w=500&h=500&fit=crop"
            alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
          ></GaleryImage>
        </GaleryItem>

        <GaleryItem>
          <GaleryImage
            src="https://images.unsplash.com/photo-1445810694374-0a94739e4a03?w=500&h=500&fit=crop"
            alt="back view of woman wearing a backpack and beanie waiting to cross the road on a busy street at night in New York City, USA"
          ></GaleryImage>
        </GaleryItem>

        <GaleryItem>
          <GaleryImage
            src="https://images.unsplash.com/photo-1486334803289-1623f249dd1e?w=500&h=500&fit=crop"
            alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
          ></GaleryImage>
        </GaleryItem>


    
/*
    <Item
      original="https://placekitten.com/1024/768?image=2"
      thumbnail="https://placekitten.com/80/60?image=2"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img
          ref={ref}
          onClick={open}
          src="https://placekitten.com/80/60?image=2"
        />
      )}
    </Item>
    */
